import { createPersistentObject } from '@/utils/cache';

export const normalizeSuperAdminFlag = (value: unknown): 0 | 1 =>
  Number(value) === 1 ? 1 : 0;

// 用户登录信息全局缓存，缓存在localStorage里面
export const userCache = createPersistentObject(
  {
    guid: '',
    token: '',
    username: '',
    userName: '',
    avatar: '',
    isSuperAdmin: 0,
    apps: [],
    currentAppUuid: '',
    permissions: [],
    permissionAppUuid: '',
    activeApiKey: '',
    activeApiKeyAppUuid: '',
    emailEnabled: 0,
  },
  'userInfoCache',
);

userCache.isSuperAdmin = normalizeSuperAdminFlag(userCache.isSuperAdmin);

export const isCurrentUserSuperAdmin = (): boolean =>
  normalizeSuperAdminFlag(userCache.isSuperAdmin) === 1;
